import AuditInviteList from './AuditInviteList';

export default AuditInviteList;
